import {
  Box, Chip, Divider, FormControl, FormLabel, Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import GlobalDateField from "../../global-fields/GlobalDateField";
import { Grid } from "@mui/system";
import style from "../../../assets/css/proposal.module.scss";
import GlobalRadio from "../../global-fields/GlobalRadio";
import GlobalTextField from "../../global-fields/GlobalTextField";
import { useFormik } from "formik";
import * as Yup from "yup";
import NewProposalFooter from "./NewProposalFooter";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectAuthState } from "../../../store/authSlice";
import { selectDataStoreState, setDataStore } from "../../../store/dataSlice";
import { setUiData } from "../../../store/uiSlice";
import { PROPOSAL_FORM } from "../../../constants/apiConstant";
import StockLocationAccordion from "./StockLocationAccordion";
import {
  initialFormValidations,
  normalizeCurrencyToNumber,
  parseToNumber,
  removeCookies,
  USD_FORMATTER,
} from "../../../constants/helper";
import GlobalNotificationPopup from "../../global-fields/GlobalNotificationPopup";
import { MANDATORY_QUES } from "../../../constants/constants";
import { motion } from "framer-motion";
import { fadeSlideIn } from "../../../constants/motionConstants";
import dayjs from "dayjs";
import {
  amountSchemaWithoutRequired,
  amountSchemaWithRequired,
  optionalAmountSchema,
} from "../../../constants/validationSchemas";
import plusIcon from "../../../assets/img/proposal-img/plus_icon.svg";
import GlobalSelectField from "../../global-fields/GlobalSelectField";

const StepSixForm = ({ leftGridWidth }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, selectedClient } = useSelector(selectAuthState);
  const {
    proposalStep,
    propStep6Data,
    proposal_id,
    previous_proposal_id,
    editingSubmitted,
    formValidations,
  } = useSelector(selectDataStoreState);
  const propStep6DataMemoize = useMemo(() => propStep6Data, [propStep6Data]);
  const [disableDraft, setDisableDraft] = useState(false);
  const peaskSeasonLimit = 6;
  const selectRefs = useRef({});
  const [additionalLocations, setAdditionalLocations] = useState([]);

  // const additional_locations =
  //   propStep6DataMemoize?.additional_addresses?.map((address, index) => ({
  //     location_id: `${address.location_id}`,
  //     location_name: `${address.street}, ${address.city}`,
  //     address,

  //     on_stock: "",
  //     peak_season: [
  //       {
  //         peak_season_amount: "",
  //         no_of_days: "",
  //       },
  //     ],
  //     on_money_locked_in_safe: "",
  //     money_robbery: "",
  //     on_patterns_mold_models: "",
  //     on_furnitures: "",
  //     on_tentants_interest: "",
  //     stock_total: "",
  //   })) || [];
 const additional_locations = useMemo(() => {
  return (
    propStep6DataMemoize?.additional_addresses?.map((address) => ({
      location_id: `${address.location_id}`,
      location_name: `${address.street}, ${address.city}`,
      address,

      on_stock: address.on_stock
        ? USD_FORMATTER.format(address.on_stock)
        : "",

      peak_season:
        address.peak_season?.length > 0
          ? address.peak_season.map((item) => ({
              peak_season_amount: item.peak_season_amount
                ? USD_FORMATTER.format(item.peak_season_amount)
                : "",
              no_of_days: item.no_of_days ?? "",
            }))
          : [
              {
                peak_season_amount: "",
                no_of_days: "",
              },
            ],

      on_money_locked_in_safe: address.on_money_locked_in_safe
        ? USD_FORMATTER.format(address.on_money_locked_in_safe)
        : "",

      money_robbery: address.money_robbery
        ? USD_FORMATTER.format(address.money_robbery)
        : "",

      on_patterns_mold_models: address.on_patterns_mold_models
        ? USD_FORMATTER.format(address.on_patterns_mold_models)
        : "",

      on_furnitures: address.on_furnitures
        ? USD_FORMATTER.format(address.on_furnitures)
        : "",

      on_tentants_interest: address.on_tentants_interest
        ? USD_FORMATTER.format(address.on_tentants_interest)
        : "",

      stock_total: address.stock_total
        ? USD_FORMATTER.format(address.stock_total)
        : "",
    })) || []
  );
}, [propStep6DataMemoize]);
  
  const initialValues = useMemo(() => ({
    step: 6,
    on_stock:
      propStep6DataMemoize?.on_stock == "0" ||
        propStep6DataMemoize?.on_stock == 0 ||
        propStep6DataMemoize?.on_stock
        ? USD_FORMATTER.format(propStep6DataMemoize?.on_stock)
        : "",
    // peak_season_amount:
    //   propStep6DataMemoize?.peak_season_amount == "0" ||
    //     propStep6DataMemoize?.peak_season_amount == 0 ||
    //     propStep6DataMemoize?.peak_season_amount
    //     ? USD_FORMATTER.format(propStep6DataMemoize?.peak_season_amount)
    //     : "",
    // peak_season_start_from: propStep6DataMemoize?.peak_season_start_from ?? "",
    // peak_season_end_on: propStep6DataMemoize?.peak_season_end_on ?? "",
    peak_season:
      propStep6DataMemoize?.peak_season?.length > 0
        ? propStep6DataMemoize.peak_season.map((item) => ({
          ...item,
          peak_season_amount:
            item?.peak_season_amount == "0" ||
              item?.peak_season_amount == 0 ||
              item?.peak_season_amount
              ? USD_FORMATTER.format(item?.peak_season_amount)
              : "",
          // peak_season_start_from: item?.peak_season_start_from ?? "",
          // peak_season_end_on: item?.peak_season_end_on ?? "",
          no_of_days: item?.no_of_days ?? "",
        }))
        : [
          {
            peak_season_amount: "",
            no_of_days: "",
            // peak_season_start_from: "",
            // peak_season_end_on: "",
          },
        ],

    on_money_locked_in_safe:
      propStep6DataMemoize?.on_money_locked_in_safe == "0" ||
        propStep6DataMemoize?.on_money_locked_in_safe == 0 ||
        propStep6DataMemoize?.on_money_locked_in_safe
        ? USD_FORMATTER.format(propStep6DataMemoize?.on_money_locked_in_safe)
        : "",
    money_robbery:
      propStep6DataMemoize?.money_robbery == "0" ||
        propStep6DataMemoize?.money_robbery == 0 ||
        propStep6DataMemoize?.money_robbery
        ? USD_FORMATTER.format(propStep6DataMemoize?.money_robbery)
        : "",
    on_patterns_mold_models:
      propStep6DataMemoize?.on_patterns_mold_models == "0" ||
        propStep6DataMemoize?.on_patterns_mold_models == 0 ||
        propStep6DataMemoize?.on_patterns_mold_models
        ? USD_FORMATTER.format(propStep6DataMemoize?.on_patterns_mold_models)
        : "",
    on_furnitures:
      propStep6DataMemoize?.on_furnitures == "0" ||
        propStep6DataMemoize?.on_furnitures == 0 ||
        propStep6DataMemoize?.on_furnitures
        ? USD_FORMATTER.format(propStep6DataMemoize?.on_furnitures)
        : "",
    on_tentants_interest:
      propStep6DataMemoize?.on_tentants_interest == "0" ||
        propStep6DataMemoize?.on_tentants_interest == 0 ||
        propStep6DataMemoize?.on_tentants_interest
        ? USD_FORMATTER.format(propStep6DataMemoize?.on_tentants_interest)
        : "",
    stock_total:
      propStep6DataMemoize?.stock_total == "0" ||
        propStep6DataMemoize?.stock_total == 0 ||
        propStep6DataMemoize?.stock_total
        ? USD_FORMATTER.format(propStep6DataMemoize?.stock_total)
        : "",

    // Additional Locations
    additional_locations: additional_locations,
    // tria_insurance:
    //   propStep6DataMemoize?.tria_insurance === "1" ||
    //     propStep6DataMemoize?.tria_insurance === 1
    //     ? 1
    //     : 0,
    // insurance_amount:
    //   propStep6DataMemoize?.insurance_amount == "0" ||
    //     propStep6DataMemoize?.insurance_amount == 0 ||
    //     propStep6DataMemoize?.insurance_amount
    //     ? USD_FORMATTER.format(propStep6DataMemoize?.insurance_amount)
    //     : "",
}), [propStep6DataMemoize, additional_locations]);
  // useEffect(() => {
  //   if (propStep6DataMemoize) {
  //     formik.setValues(initialValues);
  //   }
  // }, [propStep6DataMemoize]);


  console.log(initialValues)

  const handleStepData = (e) => {
    if (!proposal_id) {
      GlobalNotificationPopup({
        type: "error",
        message: "Please Fillout Initial/Business Details Form First.",
      });
      return;
    }
    dispatch(setUiData({ showLoader: true }));
    // const unformat = (val) => val?.toString().replace(/[^0-9.]/g, "") || "0";

    let cleanedData = { ...e };

    // Clean the losses array if present
    if (Array.isArray(cleanedData.peak_season)) {
      // cleanedData.peak_season = cleanedData.peak_season.map((ps) => ({
      //   peak_season_amount: normalizeCurrencyToNumber(ps.peak_season_amount),
      //   peak_season_start_from: ps.peak_season_start_from
      //     ? dayjs(ps.peak_season_start_from).format("MM-DD-YYYY")
      //     : "",
      //   peak_season_end_on: ps.peak_season_end_on
      //     ? dayjs(ps.peak_season_end_on).format("MM-DD-YYYY")
      //     : "",
      // }));
      cleanedData.peak_season = cleanedData.peak_season.map((ps) => ({
        peak_season_amount: normalizeCurrencyToNumber(ps.peak_season_amount),
        no_of_days: ps.no_of_days,
      }));
    }

    let cleanedAdditionalLocations = [];

    if (Array.isArray(e.additional_locations)) {
      cleanedAdditionalLocations = e.additional_locations.map((location) => ({
        ...location,
        on_stock: normalizeCurrencyToNumber(location.on_stock),
        on_money_locked_in_safe: normalizeCurrencyToNumber(
          location.on_money_locked_in_safe
        ),
        money_robbery: normalizeCurrencyToNumber(location.money_robbery),
        on_patterns_mold_models: normalizeCurrencyToNumber(
          location.on_patterns_mold_models
        ),
        on_furnitures: normalizeCurrencyToNumber(location.on_furnitures),
        on_tentants_interest: normalizeCurrencyToNumber(
          location.on_tentants_interest
        ),
        stock_total: normalizeCurrencyToNumber(location.stock_total),
        peak_season: location.peak_season?.map((ps) => ({
          ...ps,
          peak_season_amount: normalizeCurrencyToNumber(ps.peak_season_amount),
        })),
      }));
    }

    let data = {
      ...cleanedData,
      additional_locations: cleanedAdditionalLocations,
      user_id: user?.id,
      proposal_id,
      proposal_status: editingSubmitted ? 1 : 0,
      previous_proposal_id: previous_proposal_id ?? null,
      step: proposalStep,
      // peak_season_start_from: e.peak_season_start_from
      //   ? dayjs(e.peak_season_start_from).format("MM-DD-YYYY")
      //   : "",
      // peak_season_end_on: e.peak_season_end_on
      //   ? dayjs(e.peak_season_end_on).format("MM-DD-YYYY")
      //   : "",
      on_stock: normalizeCurrencyToNumber(e.on_stock),
      // peak_season_amount: normalizeCurrencyToNumber(e.peak_season_amount),
      on_money_locked_in_safe: normalizeCurrencyToNumber(
        e.on_money_locked_in_safe
      ),
      money_robbery: normalizeCurrencyToNumber(e.money_robbery),
      on_patterns_mold_models: normalizeCurrencyToNumber(
        e.on_patterns_mold_models
      ),
      on_furnitures: normalizeCurrencyToNumber(e.on_furnitures),
      on_tentants_interest: normalizeCurrencyToNumber(e.on_tentants_interest),
      stock_total: normalizeCurrencyToNumber(e.stock_total),
      // insurance_amount: normalizeCurrencyToNumber(e.insurance_amount),
    };
    if (user?.user_type === "agent") {
      data = { ...data, user_id: selectedClient?.user_id, agent_id: user?.id };
    }
    const options = {
      method: PROPOSAL_FORM.method,
      headers: PROPOSAL_FORM.headers,
      body: JSON.stringify(data),
    };

    fetch(PROPOSAL_FORM.url, options)
      .then((response) => response.json())
      .then((res) => {
        if (res.status == 0) {
          dispatch(setUiData({ showLoader: false }));
          formik.resetForm();
        } else if (res.status == 1) {
          formik.resetForm();
          dispatch(
            setDataStore({
              proposalStep: proposalStep + 1,
            })
          );
          dispatch(setUiData({ showLoader: false }));
        }
        if (e?.save_draft) {
          setDisableDraft(false);
        }
      })
      .catch((error) => {
        dispatch(
          setDataStore({
            proposalStep: 1,
            proposal_id: null,
            previous_proposal_id: null,
            editingSubmitted: false,
            clickedSteps: [],
            formValidations: initialFormValidations,
          })
        );
        removeCookies("isLogin");
        GlobalNotificationPopup({ type: "error", message: error });
        console.log("error", error);
        dispatch(setUiData({ showLoader: false }));
        navigate("/");
        formik.resetForm();
      });
  };

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: Yup.object({
      on_stock: optionalAmountSchema,
      // peak_season_amount: amountSchemaWithoutRequired,
      // peak_season_start_from: Yup.string(),
      // peak_season_end_on: Yup.string(),
      // peak_season: Yup.array().of(
      //   Yup.object().shape({
      //     peak_season_amount: amountSchemaWithoutRequired,
      //     peak_season_start_from: Yup.string(),
      //     peak_season_end_on: Yup.string(),
      //   })
      // ),
      peak_season: Yup.array().of(
        Yup.object().shape({
          peak_season_amount: amountSchemaWithoutRequired,
          no_of_days: Yup.number()
            .typeError("Please enter valid number of days")
            .integer("Must be an integer")
            .min(1, "Minimum 1 day")
            .nullable(),
        })
      ),

      on_money_locked_in_safe: amountSchemaWithoutRequired,
      money_robbery: amountSchemaWithoutRequired,
      on_patterns_mold_models: amountSchemaWithoutRequired,
      on_furnitures: amountSchemaWithoutRequired,
      on_tentants_interest: amountSchemaWithoutRequired,
      stock_total: amountSchemaWithoutRequired,
    }),
    onSubmit: (values) => {
      //console.log("Form submitted 6:", values);
      handleStepData(values);
    },
  });
  const handleCustomSubmit = async (e) => {
    const errors = await formik.validateForm();

    if (Object.keys(errors).length > 0) {
      const updated = formValidations.map((item) => {
        if (item.step === 6) {
          return { ...item, status: 2 };
        }
        return item;
      });

      dispatch(
        setDataStore({
          formValidations: updated,
        })
      );

      formik.handleSubmit(); // still runs to show errors
    } else {
      formik.handleSubmit(); // successful submit
    }
  };

  const handleChangeAndUpdateTotalOLD = (fieldName, rawValue) => {
    // Remove non-numeric characters except for decimal points
    const numericValue = rawValue.replace(/[^0-9.]/g, ""); // Keep numbers and decimals
    const isValidNumber =
      numericValue === "" || /^\d*\.?\d*$/.test(numericValue); // Allow decimals

    if (isValidNumber) {
      formik.setValues((prevValues) => {
        // Convert valid value to number or leave as an empty string if invalid
        const updatedValue =
          numericValue === "" ? "" : parseFloat(numericValue) || 0;

        // Update the current field with formatted value
        const updatedValues = {
          ...prevValues,
          [fieldName]:
            numericValue === "" ? "" : USD_FORMATTER.format(updatedValue), // Format value for display
        };

        // Extract numeric values and sum them to calculate stock_total
        const total = [
          updatedValues.on_money_locked_in_safe,
          updatedValues.money_robbery,
          updatedValues.on_patterns_mold_models,
          updatedValues.on_furnitures,
          updatedValues.on_tentants_interest,
        ]
          .map((val) => parseFloat(val.replace(/[$,]/g, "")) || 0) // Parse formatted values
          .reduce((acc, curr) => acc + curr, 0);

        return {
          ...updatedValues,
          stock_total: USD_FORMATTER.format(total), // Format total to currency
        };
      });
    }
  };
  const handleChangeAndUpdateTotal = (fieldName, rawValue) => {
    // Keep digits and at most one dot
    let cleanedValue = rawValue.replace(/[^0-9.]/g, "");
    const parts = cleanedValue.split(".");
    if (parts.length > 2) {
      cleanedValue = parts[0] + "." + parts.slice(1).join("");
    }

    // Validate number format (allow decimals)
    const isValidNumber =
      cleanedValue === "" || /^\d*\.?\d*$/.test(cleanedValue);
    if (!isValidNumber) return;

    formik.setValues((prevValues) => {
      // Format the current field with commas, keep decimal part up to 2 digits
      let formattedValue = "";
      if (cleanedValue !== "") {
        const [integerPart, decimalPart] = cleanedValue.split(".");
        formattedValue =
          "$" + new Intl.NumberFormat("en-US").format(Number(integerPart));
        if (decimalPart !== undefined) {
          formattedValue += "." + decimalPart.slice(0, 2);
        }
      }

      const updatedValues = {
        ...prevValues,
        [fieldName]: formattedValue,
      };

      // Calculate total
      const total = [
        updatedValues.on_money_locked_in_safe,
        updatedValues.money_robbery,
        updatedValues.on_patterns_mold_models,
        updatedValues.on_furnitures,
        updatedValues.on_tentants_interest,
      ]
        .map((val) => {
          if (!val) return 0;
          const numeric = parseFloat(val.replace(/[$,]/g, ""));
          return isNaN(numeric) ? 0 : numeric;
        })
        .reduce((acc, curr) => acc + curr, 0);

      return {
        ...updatedValues,
        stock_total:
          "$" +
          total.toLocaleString("en-US", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          }),
      };
    });
  };

  const handlePlusPeakSeason = useCallback(() => {
    const lastpeak_season =
      formik.values.peak_season[formik.values.peak_season.length - 1];

    // if (
    //   !lastpeak_season.peak_season_amount ||
    //   !lastpeak_season.peak_season_start_from ||
    //   !lastpeak_season.peak_season_end_on
    // ) {
    if (
      !lastpeak_season.peak_season_amount ||
      !lastpeak_season.no_of_days
    ) {
      GlobalNotificationPopup({
        type: "warning",
        message: "Please fill all fields before adding a new entry.",
      });
      return;
    }

    if (formik.values.peak_season.length >= peaskSeasonLimit) return;

    formik.setFieldValue("peak_season", [
      ...formik.values.peak_season,
      {
        // peak_season_amount: "",
        // peak_season_start_from: "",
        // peak_season_end_on: "",
        peak_season_amount: "",
        no_of_days: "",
      },
    ]);
  }, [formik.values.peak_season]);

  const handleMinusPeakSeason = useCallback(
    (index) => {
      if (formik.values.peak_season.length === 1) return;

      const newpeak_season = [...formik.values.peak_season];
      newpeak_season.splice(index, 1);
      formik.setFieldValue("peak_season", newpeak_season);
    },
    [formik.values.peak_season]
  );

  const handleAmountFieldChangeOLD = (e, index, fieldName) => {
    const rawValue = e.target.value;
    const numericValue = parseToNumber(rawValue);
    //console.log("numericValue", rawValue, numericValue, USD_FORMATTER.format(numericValue));
    // Format the value back to currency format for display
    formik.setFieldValue(
      fieldName,
      numericValue !== "" ? USD_FORMATTER.format(numericValue) : ""
    );
  };
  const handleAmountFieldChange = (e, index, fieldName) => {
    let rawValue = e.target.value;

    // Ensure it always starts with $
    if (!rawValue.startsWith("$")) rawValue = "$" + rawValue;

    // Extract numeric part
    const numericValue = parseToNumber(rawValue);

    // Allow typing "$" or "$." without formatting
    if (rawValue === "$" || rawValue === "$.") {
      formik.setFieldValue(fieldName, rawValue);
      return;
    }

    // Format integer part with commas, keep decimal part as typed
    let formatted = "$";
    if (numericValue !== "") {
      const [integerPart, decimalPart] = rawValue
        .replace(/[^0-9.]/g, "")
        .split(".");

      // Format integer with commas
      formatted += new Intl.NumberFormat("en-US").format(Number(integerPart));

      // Append decimal part if exists, limit to 2 digits
      if (decimalPart !== undefined) {
        formatted += "." + decimalPart.slice(0, 2);
      }
    }

    formik.setFieldValue(fieldName, formatted);
  };
  // console.log("formik", formik.dirty, formik.values, formik.errors);
  //console.log("propStep6DataMemoize", propStep6DataMemoize);

  const handleSaveDraft = useCallback(() => {
    const { values } = formik;
    setDisableDraft(true);
    let vals = { ...values, save_draft: true };
    // console.log("vals", vals);
    //return;
    handleStepData(vals);
  }, [formik]);

  const handleLocationChange = (locationIndex, field, value) => {
    const locations = [...formik.values.additional_locations];

    locations[locationIndex][field] = value;

    const parseAmount = (val) => {
      if (!val) return 0;
      return parseFloat(val.toString().replace(/[$,]/g, "")) || 0;
    };

    const total =
      parseAmount(locations[locationIndex].on_money_locked_in_safe) +
      parseAmount(locations[locationIndex].money_robbery) +
      parseAmount(locations[locationIndex].on_patterns_mold_models) +
      parseAmount(locations[locationIndex].on_furnitures) +
      parseAmount(locations[locationIndex].on_tentants_interest);

    locations[locationIndex].stock_total =
      "$" +
      total.toLocaleString("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });

    formik.setFieldValue("additional_locations", locations);
  };
  // const handleLocationChange = (locationIndex, field, value) => {
  //   formik.setFieldValue(
  //     `additional_locations.${locationIndex}.${field}`,
  //     value
  //   );
  // };

  const handleAddPeakSeason = (locationIndex) => {
    const locations = [...formik.values.additional_locations];

    locations[locationIndex].peak_season.push({
      peak_season_amount: "",
      no_of_days: "",
    });

    formik.setFieldValue("additional_locations", locations);
  };

  const handleRemovePeakSeason = (locationIndex, peakIndex) => {
    const locations = [...formik.values.additional_locations];

    locations[locationIndex].peak_season.splice(peakIndex, 1);

    formik.setFieldValue("additional_locations", locations);
  };

  return (
    <>
      <section className={style.proposalMain}>
        <motion.div {...fadeSlideIn}>
          <Box className={style.proposalMainD}>
            {selectedClient !== null ? (
              <div className={style.client_title}>
                <p> On behalf of Client : </p>
                <h3>
                  {selectedClient?.first_name} {selectedClient?.last_name}{" "}
                </h3>
                {/* <span>{selectedClient?.email} </span> */}
                <Divider />
              </div>
            ) : null}
            <h2 className={style.propo_title}>Stock Limits</h2>
            <form
              autoComplete="false"
              autoSave="false"
              onSubmit={handleCustomSubmit}
            >
              <Accordion
                defaultExpanded
                sx={{
                  mb: 2, // Space between accordions
                  borderRadius: "8px",
                  overflow: "hidden",
                  boxShadow: "none",
                  border: "1px solid #d9e2ec",
                  "&:before": {
                    display: "none",
                  },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{
                    backgroundColor: "#f5f9fc", // Light blue background
                    minHeight: "56px",
                    "& .MuiAccordionSummary-content": {
                      margin: "12px 0",
                    },
                    "&.Mui-expanded": {
                      minHeight: "56px",
                    },
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      color: "#0b5c7c",
                      fontWeight: 600,
                    }}
                  >
                    Default Location
                  </Typography>
                </AccordionSummary>

                <AccordionDetails
                  sx={{
                    p: 3, // Increase inner spacing
                    backgroundColor: "#fff",
                  }}
                >




                  <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 12 }}>
                      <h2 className={style.formTitleh2}>
                        14) Amount(s) of Insurance Desired
                      </h2>
                    </Grid>
                    <Grid size={{ xs: 12, md: 8 }}>
                      <Grid container spacing={2}>
                        <Grid size={{ xs: 12, md: 12 }}>
                          <FormControl fullWidth sx={{ mt: 1 }}>
                            <FormLabel sx={{ mb: 1 }}>On stock </FormLabel>
                            <GlobalTextField
                              placeH="$"
                              type="text"
                              name={`on_stock`}
                              id={`_on_stock`}
                              value={formik.values?.on_stock}
                              onChange={(e) =>
                                handleChangeAndUpdateTotal(
                                  "on_stock",
                                  e.target.value
                                )
                              }
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched?.on_stock &&
                                Boolean(formik.errors?.on_stock)
                              }
                              helperText={
                                formik.touched?.on_stock && formik.errors?.on_stock
                              }
                            />
                          </FormControl>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid size={{ xs: 12, md: 8 }}>
                      <Grid container spacing={2}>
                        <Grid size={{ xs: 12, md: 12 }}>
                          <div className={style.plusIconMain}>
                            <Box sx={{ mt: 1 }}>
                              <h3 className={style.htitleText}>Peak Season</h3>
                            </Box>
                            <div className={style.plusImgMain}>
                              {/* Add Icon - Show only at index 0 and if the limit is not exceeded */}
                              {formik.values.peak_season.length <
                                peaskSeasonLimit && (
                                  <p
                                    style={{
                                      position: "inherit",
                                      display: "flex",
                                    }}
                                    onClick={handlePlusPeakSeason}
                                  >
                                    <img
                                      src={plusIcon}
                                      alt="Add"
                                      style={{ marginRight: "5px" }}
                                    />
                                    Add
                                  </p>
                                )}
                            </div>
                          </div>
                        </Grid>
                        {formik.values.peak_season.map((ent, index) => {
                          return (
                            <>
                              {index !== 0 && (
                                <Box sx={{ width: "100%", mt: 1, mb: 0 }}>
                                  <Divider sx={{ position: "relative" }}>
                                    <Chip
                                      label={` ${index + 1}`}
                                      size="medium"
                                      clickable
                                      onDelete={() => handleMinusPeakSeason(index)}
                                    />
                                  </Divider>
                                </Box>
                              )}
                              <Grid size={{ xs: 12, md: 4 }}>
                                <FormControl fullWidth>
                                  <FormLabel sx={{ mb: 1 }}>Amount</FormLabel>
                                </FormControl>
                                <GlobalTextField
                                  placeH="$"
                                  type="text"
                                  name={`peak_season[${index}].peak_season_amount`}
                                  labelId={`peak_season_${index}_peak_season_amount`}
                                  value={
                                    formik.values?.peak_season?.[index]
                                      ?.peak_season_amount || ""
                                  }
                                  onChange={(e) =>
                                    handleAmountFieldChange(
                                      e,
                                      index,
                                      `peak_season.[${index}].peak_season_amount`
                                    )
                                  }
                                  onBlur={formik.handleBlur}
                                  error={
                                    formik.touched?.peak_season?.[index]
                                      ?.peak_season_amount &&
                                    Boolean(
                                      formik.errors?.peak_season?.[index]
                                        ?.peak_season_amount
                                    )
                                  }
                                  helperText={
                                    formik.touched?.peak_season?.[index]
                                      ?.peak_season_amount &&
                                    formik.errors?.peak_season?.[index]
                                      ?.peak_season_amount
                                  }
                                />
                              </Grid>

                              <Grid size={{ xs: 12, md: 4 }}>
                                <FormControl fullWidth>
                                  <FormLabel sx={{ mb: 1 }}>No. of Days</FormLabel>

                                  <GlobalTextField
                                    type="number"
                                    name={`peak_season[${index}].no_of_days`}
                                    value={formik.values?.peak_season?.[index]?.no_of_days || ""}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={
                                      formik.touched?.peak_season?.[index]?.no_of_days &&
                                      Boolean(formik.errors?.peak_season?.[index]?.no_of_days)
                                    }
                                    helperText={
                                      formik.touched?.peak_season?.[index]?.no_of_days &&
                                      formik.errors?.peak_season?.[index]?.no_of_days
                                    }
                                    inputProps={{
                                      min: 1,
                                    }}
                                  />
                                </FormControl>
                              </Grid>

                              {/* <Grid size={{xs: 12, md: 4}}>
                                <FormControl fullWidth>
                                  <FormLabel sx={{mb: 1}}>Starting from</FormLabel>
                                </FormControl>
                                <GlobalDateField
                                  name={`peak_season[${index}].peak_season_start_from`}
                                  labelId={`peak_season_${index}_peak_season_start_from`}
                                  value={
                                    formik.values?.peak_season?.[index]
                                      ?.peak_season_start_from || ""
                                  }
                                  onChange={(newValue) => {
                                    formik.setFieldValue(
                                      `peak_season.[${index}].peak_season_start_from`,
                                      newValue
                                    );
                                    // If user cleared the start date, clear the end date too
                                    if (!newValue) {
                                      formik.setFieldValue(
                                        `peak_season.[${index}].peak_season_end_on`,
                                        ""
                                      );
                                    }
                                  }}
                                  onBlur={formik.handleBlur}
                                  error={
                                    formik.touched?.peak_season?.[index]
                                      ?.peak_season_start_from &&
                                    Boolean(
                                      formik.errors?.peak_season?.[index]
                                        ?.peak_season_start_from
                                    )
                                  }
                                  helperText={
                                    formik.touched?.peak_season?.[index]
                                      ?.peak_season_start_from &&
                                    formik.errors?.peak_season?.[index]
                                      ?.peak_season_start_from
                                  }
                                  disablePast
                                  clearBtn={
                                    formik.values?.peak_season?.[index]
                                      ?.peak_season_start_from !== ""
                                  }
                                />
                              </Grid>

                              <Grid size={{xs: 12, md: 4}}>
                                <FormControl fullWidth>
                                  <FormLabel sx={{mb: 1}}> Ending on </FormLabel>
                                </FormControl>

                                <GlobalDateField
                                  dependentMinValue={
                                    formik.values?.peak_season?.[index]
                                      ?.peak_season_start_from
                                  }
                                  name={`peak_season[${index}].peak_season_end_on`}
                                  labelId={`peak_season_${index}_peak_season_end_on`}
                                  value={
                                    formik.values?.peak_season?.[index]
                                      ?.peak_season_end_on || ""
                                  }
                                  onChange={(newValue) => {
                                    formik.setFieldValue(
                                      `peak_season.[${index}].peak_season_end_on`,
                                      newValue
                                    );
                                  }}
                                  onBlur={formik.handleBlur}
                                  error={
                                    formik.touched?.peak_season?.[index]
                                      ?.peak_season_end_on &&
                                    Boolean(
                                      formik.errors?.peak_season?.[index]
                                        ?.peak_season_end_on
                                    )
                                  }
                                  helperText={
                                    formik.touched?.peak_season?.[index]
                                      ?.peak_season_end_on &&
                                    formik.errors?.peak_season?.[index]
                                      ?.peak_season_end_on
                                  }
                                  disablePast
                                  disabled={
                                    formik.values?.peak_season?.[index]
                                      ?.peak_season_start_from == "" ||
                                    formik.values?.peak_season?.[index]
                                      ?.peak_season_start_from == null
                                  }
                                  clearBtn={
                                    formik.values?.peak_season?.[index]
                                      ?.peak_season_end_on !== ""
                                  }
                                />
                              </Grid> */}
                            </>
                          );
                        })}
                      </Grid>
                    </Grid>

                    {/* <Grid size={{ xs: 12, md: 8 }}>
                      <Grid container spacing={2}>


                        <Grid size={{ xs: 12, md: 4 }}>
                          <FormControl fullWidth sx={{ mt: 1 }}>
                            <FormLabel sx={{ mb: 1 }}>Peak Season Amount</FormLabel>
                            <GlobalTextField
                              placeH="$"
                              type="text"
                              name={`peak_season_amount`}
                              id={`_peak_season_amount`}
                              value={formik.values?.peak_season_amount}
                              onChange={(e) =>
                                handleChangeAndUpdateTotal(
                                  "peak_season_amount",
                                  e.target.value
                                )
                              }
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched?.peak_season_amount &&
                                Boolean(formik.errors?.peak_season_amount)
                              }
                              helperText={
                                formik.touched?.peak_season_amount &&
                                formik.errors?.peak_season_amount
                              }
                            />
                          </FormControl>
                        </Grid>

                        <Grid size={{ xs: 12, md: 4 }}>
                          <FormControl fullWidth sx={{ mt: 1 }}>
                            <FormLabel sx={{ mb: 1 }}>
                              Peak Season starting from
                            </FormLabel>
                            <GlobalDateField
                              name={`peak_season_start_from`}
                              value={formik.values.peak_season_start_from}
                              // onChange={(newValue) =>
                              //   formik.setFieldValue(
                              //     `peak_season_start_from`,
                              //     newValue
                              //   )
                              // }
                              onChange={(newValue) => {
                                formik.setFieldValue(
                                  "peak_season_start_from",
                                  newValue
                                );

                                // If user cleared the start date, clear the end date too
                                if (!newValue) {
                                  formik.setFieldValue("peak_season_end_on", "");
                                }
                              }}
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched?.peak_season_start_from &&
                                Boolean(formik.errors?.peak_season_start_from)
                              }
                              helperText={
                                formik.touched?.peak_season_start_from &&
                                formik.errors?.peak_season_start_from
                              }
                              disablePast
                              clearBtn={formik.values.peak_season_start_from !== ""}
                            />
                          </FormControl>
                        </Grid>

                        <Grid size={{ xs: 12, md: 4 }}>
                          <FormControl fullWidth sx={{ mt: 1 }}>
                            <FormLabel sx={{ mb: 1 }}>
                              Peak Season Ending on
                            </FormLabel>
                            <GlobalDateField
                              dependentMinValue={
                                formik.values.peak_season_start_from
                              }
                              name={`peak_season_end_on`}
                              value={formik.values.peak_season_end_on}
                              onChange={(newValue) =>
                                formik.setFieldValue(`peak_season_end_on`, newValue)
                              }
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched?.peak_season_end_on &&
                                Boolean(formik.errors?.peak_season_end_on)
                              }
                              helperText={
                                formik.touched?.peak_season_end_on &&
                                formik.errors?.peak_season_end_on
                              }
                              disablePast
                              disabled={
                                formik.values.peak_season_start_from == "" ||
                                formik.values.peak_season_start_from == null
                              }
                              clearBtn={formik.values.peak_season_end_on !== ""}
                            />
                          </FormControl>
                        </Grid>
                      </Grid>
                    </Grid> */}
                  </Grid>

                  <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 12, lg: 12, xl: 12 }} sx={{ mt: 3 }}>
                      <h3 className={style.htitleText}>
                        On money in Locked Safe or Proposer’s Premises against theft
                        by safe being broken open
                      </h3>
                    </Grid>
                    <Grid size={{ xs: 12, md: 8 }}>
                      <FormControl fullWidth>
                        <GlobalTextField
                          placeH="$"
                          type="text"
                          name={`on_money_locked_in_safe`}
                          id={`_on_money_locked_in_safe`}
                          value={formik.values?.on_money_locked_in_safe}
                          onChange={(e) =>
                            handleChangeAndUpdateTotal(
                              "on_money_locked_in_safe",
                              e.target.value
                            )
                          }
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched?.on_money_locked_in_safe &&
                            Boolean(formik.errors?.on_money_locked_in_safe)
                          }
                          helperText={
                            formik.touched?.on_money_locked_in_safe &&
                            formik.errors?.on_money_locked_in_safe
                          }
                        />
                      </FormControl>
                    </Grid>
                    <Grid size={{ xs: 12, md: 12, lg: 12, xl: 12 }} sx={{ mt: 1 }}>
                      <h3 className={style.htitleText}>
                        Money off premises
                      </h3>
                    </Grid>
                    <Grid size={{ xs: 12, md: 8 }}>
                      <FormControl fullWidth>
                        <GlobalTextField
                          placeH="$"
                          type="text"
                          name={`money_robbery`}
                          id={`_money_robbery`}
                          value={formik.values?.money_robbery}
                          onChange={(e) =>
                            handleChangeAndUpdateTotal(
                              "money_robbery",
                              e.target.value
                            )
                          }
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched?.money_robbery &&
                            Boolean(formik.errors?.money_robbery)
                          }
                          helperText={
                            formik.touched?.money_robbery &&
                            formik.errors?.money_robbery
                          }
                        />
                      </FormControl>
                    </Grid>

                    <Grid size={{ xs: 12, md: 12, lg: 12, xl: 6 }} sx={{ mt: 1 }}>
                      <h3 className={style.htitleText}>
                        On patterns, Molds, Models and Dies, at Proposer’s premise
                      </h3>
                    </Grid>
                    <Grid size={{ xs: 12, md: 8 }}>
                      <FormControl fullWidth>
                        <GlobalTextField
                          placeH="$"
                          type="text"
                          name={`on_patterns_mold_models`}
                          id={`_on_patterns_mold_models`}
                          value={formik.values?.on_patterns_mold_models}
                          onChange={(e) =>
                            handleChangeAndUpdateTotal(
                              "on_patterns_mold_models",
                              e.target.value
                            )
                          }
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched?.on_patterns_mold_models &&
                            Boolean(formik.errors?.on_patterns_mold_models)
                          }
                          helperText={
                            formik.touched?.on_patterns_mold_models &&
                            formik.errors?.on_patterns_mold_models
                          }
                        />
                      </FormControl>
                    </Grid>
                    <Grid size={{ xs: 12, md: 12, lg: 12, xl: 6 }} sx={{ mt: 1 }}>
                      <h3 className={style.htitleText}>
                        On Furniture, Fixtures, Tools, Machinery and Fittings at
                        proposer’s premises
                      </h3>
                    </Grid>
                    <Grid size={{ xs: 12, md: 8 }}>
                      <FormControl fullWidth>
                        <GlobalTextField
                          placeH="$"
                          type="text"
                          name={`on_furnitures`}
                          id={`_on_furnitures`}
                          value={formik.values?.on_furnitures}
                          onChange={(e) =>
                            handleChangeAndUpdateTotal(
                              "on_furnitures",
                              e.target.value
                            )
                          }
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched?.on_furnitures &&
                            Boolean(formik.errors?.on_furnitures)
                          }
                          helperText={
                            formik.touched?.on_furnitures &&
                            formik.errors?.on_furnitures
                          }
                        />
                      </FormControl>
                    </Grid>
                    <Grid size={{ xs: 12, md: 12, lg: 12, xl: 6 }} sx={{ mt: 1 }}>
                      <h3 className={style.htitleText}>
                        On Tenant’s Interest in Improvements and Betterments to
                        building(s)
                      </h3>
                    </Grid>
                    <Grid size={{ xs: 12, md: 8 }}>
                      <FormControl fullWidth>
                        <GlobalTextField
                          placeH="$"
                          type="text"
                          name={`on_tentants_interest`}
                          id={`_on_tentants_interest`}
                          value={formik.values?.on_tentants_interest}
                          onChange={(e) =>
                            handleChangeAndUpdateTotal(
                              "on_tentants_interest",
                              e.target.value
                            )
                          }
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched?.on_tentants_interest &&
                            Boolean(formik.errors?.on_tentants_interest)
                          }
                          helperText={
                            formik.touched?.on_tentants_interest &&
                            formik.errors?.on_tentants_interest
                          }
                        />
                      </FormControl>
                    </Grid>
                    <Grid size={{ xs: 12, md: 12, lg: 12, xl: 6 }} sx={{ mt: 1 }}>
                      <h3 className={style.htitleText}>Total</h3>
                    </Grid>
                    <Grid size={{ xs: 12, md: 8 }}>
                      <FormControl fullWidth>
                        <GlobalTextField
                          placeH="$"
                          type="text"
                          name={`stock_total`}
                          id={`_stock_total`}
                          value={formik.values?.stock_total}
                          error={
                            formik.touched?.stock_total &&
                            Boolean(formik.errors?.stock_total)
                          }
                          helperText={
                            formik.touched?.stock_total &&
                            formik.errors?.stock_total
                          }
                          disabled
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                  {/* <Grid container spacing={2} sx={{ mt: 3 }}>
                    <Grid size={{ xs: 12, md: 12 }}>
                      <h2 className={style.formTitleh2}>15) Optional Coverages</h2>
                    </Grid>
                  </Grid>
                  
                  <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid size={{ xs: 12, md: 6, xl: 4 }}>
                      <h3 className={style.htitleText}>
                        Do you want TRIA insurance?
                      </h3>

                      <Grid container spacing={2} sx={{ mt: 2 }}>
                        <Grid size={{ xs: 12, md: 6 }}>
                          <GlobalRadio
                            title="Yes"
                            selected={formik.values.tria_insurance === 1}
                            onClick={(e) => {
                              e.preventDefault();
                              formik.setFieldValue("tria_insurance", 1);
                            }}
                            error={
                              formik.touched.tria_insurance &&
                              Boolean(formik.errors.tria_insurance)
                            }
                            errorText={
                              formik.touched.tria_insurance &&
                              formik.errors.tria_insurance
                            }
                          />
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                          <GlobalRadio
                            title="No"
                            selected={formik.values.tria_insurance !== 1}
                            onClick={(e) => {
                              e.preventDefault();
                              formik.setValues((prevValues) => ({
                                ...prevValues,
                                tria_insurance: 0,
                                insurance_amount: "",
                              }));
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                    {formik.values.tria_insurance === 1 ? (
                      <Grid size={{ xs: 12, md: 4 }}>
                        <h3 className={style.htitleText}>Deductible *</h3>
                        <Grid container spacing={2}>
                          <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 2 }}>
                            <GlobalTextField
                              placeH={
                                formik.values.tria_insurance === 1
                                  ? "$"
                                  : "No Fire Insurance Selected."
                              }
                              type="text"
                              value={formik.values.insurance_amount}
                              onChange={(e) =>
                                handleChangeAndUpdateTotal(
                                  "insurance_amount",
                                  e.target.value
                                )
                              }
                              onBlur={formik.handleBlur}
                              id="insurance_amount"
                              name="insurance_amount"
                              error={
                                formik.touched.insurance_amount &&
                                Boolean(formik.errors.insurance_amount)
                              }
                              helperText={
                                formik.touched.insurance_amount &&
                                formik.errors.insurance_amount
                              }
                              disabled={formik.values.tria_insurance !== 1}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    ) : null}
                  </Grid> */}
                </AccordionDetails>
              </Accordion>
              {formik.values.additional_locations?.map((location, index) => (
                <StockLocationAccordion
                  formik={formik}
                  index={index}
                  location={location}
                  style={style}
                  plusIcon={plusIcon}
                  peaskSeasonLimit={peaskSeasonLimit}
                  handleLocationChange={handleLocationChange}
                  handleAmountFieldChange={handleAmountFieldChange}
                  handleAddPeakSeason={handleAddPeakSeason}
                  handleRemovePeakSeason={handleRemovePeakSeason}
                />
              ))}

            </form>
          </Box>
        </motion.div>
        <NewProposalFooter
          submitForm={handleCustomSubmit}
          leftGridWidth={leftGridWidth}
          nextPage={
            formik.values?.on_stock != "" &&
            !formik.dirty &&
            propStep6DataMemoize !== null
          }
          handleSaveDraft={handleSaveDraft}
          disableDraft={disableDraft}
        />
      </section>
    </>
  );
};

export default StepSixForm;
